export enum BuilderSliderSteps {
  MAIN_IMAGE = "Main image",
  SELECTION = "Selections",
  KITCHEN = "Kitchen",
  BATHROOM = "Bathroom",
  LIVING = "Living",
  FLOORPLAN = "Floorplan",
}
